import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react'

type AccountsHeaderContextValue = {
  setHeaderButtons: Dispatch<SetStateAction<React.ReactNode | null>>
  setHeaderTitle: Dispatch<SetStateAction<React.ReactNode | null>>
  setShowSidebar: Dispatch<SetStateAction<boolean>>
}

const AccountsHeaderContext = createContext<AccountsHeaderContextValue | null>(
  null,
)

export function AccountsHeaderProvider({
  value,
  children,
}: {
  value: AccountsHeaderContextValue
  children: React.ReactNode
}): React.ReactElement {
  return (
    <AccountsHeaderContext.Provider value={value}>
      {children}
    </AccountsHeaderContext.Provider>
  )
}

export function useAccountsHeader(): AccountsHeaderContextValue {
  const ctx = useContext(AccountsHeaderContext)
  if (!ctx) {
    throw new Error(
      'useAccountsHeader must be used within AccountsHeaderProvider',
    )
  }
  return ctx
}
